import React__default from 'react';

/**
 * Render a table row representing a week in the calendar.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Week(props) {
    const { week, ...trProps } = props;
    return React__default.createElement("tr", { ...trProps });
}

export { Week };
